const PaytronIcon = (props) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            <svg height={props.height || '20'} viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill={props.colour === 'blue' ? '#133D9E' : '#FFF'}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.89792 0C8.82798 0 11.0775 0.523062 12.6465 1.56919C14.2155 2.59629 15 4.28911 15 6.64765C15 9.0252 14.206 10.7466 12.6181 11.8117C11.0302 12.8578 8.76182 13.3809 5.81285 13.3809H4.42344V20H0V7.44053L4.80636 7.87035L4.80642 9.75676C4.80642 9.91607 4.86306 10.0701 4.9661 10.1911C5.2045 10.4709 5.62323 10.5033 5.90136 10.2635L10.8517 7.04282C11.2036 6.73934 11.1299 6.26926 10.8517 6.02939L5.90136 2.80874C5.78115 2.70506 5.62804 2.64807 5.4697 2.64807C5.10338 2.64807 4.80642 2.94687 4.80642 3.31546L4.80636 5.20081L0 5.71306V0.513552C0.964083 0.323348 1.98488 0.190205 3.06238 0.114123C4.13989 0.038041 5.08507 0 5.89792 0Z"
                />
            </svg>
        </div>
    );
};

export default PaytronIcon;
